var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from 'styled-components';
export var addMobileStyles = function (styles) {
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    @media screen and (max-width: ", "px) {\n      ", "\n    }\n  "], ["\n    @media screen and (max-width: ", "px) {\n      ", "\n    }\n  "])), function (props) { return props.theme.breakpoints.md; }, styles);
};
var templateObject_1;
